import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

// NOTE: React.StrictMode removed to prevent OOM crashes from performance profiling
// when dealing with large state objects (candles, hftCandles arrays).
// StrictMode causes double-renders and triggers DataCloneError when React tries
// to serialize large objects for performance measurement.
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
